// src/components/geo/GeoPermissionDeniedBanner.jsx
import React, { useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { GeofenceService } from '../../services/GeofenceService';
import Style from "../../styles/pages/GeoPermissionDeniedBanner.module.css";

const NEEDS_MODAL = ['denied', 'whenInUse', 'restricted'];

export default function GeoPermissionDeniedBanner({ permissionStatus, onDismiss }) {
  const [dismissed, setDismissed] = useState(false);
  const [opening, setOpening] = useState(false);

  // v3.7.3 (Bloco C): fechar AVISA o dono (persistência do "Ignorar" — o
  // cooldown de 14 dias vive fora, no geoBannerGate/useGeofence). Antes o
  // onDismiss era ignorado e o snooze nunca era gravado: o modal voltava a
  // cada abertura do app.
  const fechar = () => {
    setDismissed(true);
    if (typeof onDismiss === "function") onDismiss();
  };

  if (!NEEDS_MODAL.includes(permissionStatus)) return null;
  if (dismissed) return null;
  if (!Capacitor.isNativePlatform()) return null;

  const isIOS       = Capacitor.getPlatform() === 'ios';
  const isWhenInUse = permissionStatus === 'whenInUse';
  const variant     = isWhenInUse ? 'Warning' : 'Danger';

  const title = isWhenInUse
    ? 'Localização parcial ativada'
    : 'Localização desativada';

  const message = isWhenInUse
    ? 'Para validar treinos automaticamente, ative "Sempre" nas configurações.'
    : 'Seus treinos não estão sendo validados para o ranking. Ative a localização nas configurações.';

  const settingsHint = isIOS
    ? isWhenInUse
      ? 'Configurações → LesVita → Localização → Sempre'
      : 'Configurações → LesVita → Localização → Sempre Permitir'
    : 'Configurações → Aplicativos → LesVita → Permissões → Localização → Permitir o tempo todo';

  const accentColor  = isWhenInUse ? '#BA7517' : '#A32D2D';
  const titleColor   = isWhenInUse ? '#633806' : '#791F1F';
  const bgColor      = isWhenInUse ? 'rgba(186,117,23,0.1)' : 'rgba(163,45,45,0.1)';

  const handleOpenSettings = async () => {
    setOpening(true);
    try {
      await GeofenceService.openSettings();
    } catch {
      if (isIOS) window.open('app-settings:');
    } finally {
      setOpening(false);
    }
  };

  return (
    <div className={Style.Overlay} onClick={fechar}>
      <div className={Style.Modal} onClick={e => e.stopPropagation()}>

        {/* Ícone centralizado */}
        <div className={Style.ModalIconWrap}>
          <svg width="40" height="40" viewBox="0 0 20 20" fill="none">
            <path
              d="M10 2C6.686 2 4 4.686 4 8c0 5 6 10 6 10s6-5 6-10c0-3.314-2.686-6-6-6z"
              stroke={accentColor} strokeWidth="1.5" fill="none" strokeLinejoin="round"
            />
            <circle cx="10" cy="8" r="2" stroke={accentColor} strokeWidth="1.5" fill="none"/>
            {!isWhenInUse && (
              <path d="M3 3l14 14" stroke={accentColor} strokeWidth="1.5" strokeLinecap="round"/>
            )}
          </svg>
        </div>

        {/* Título */}
        <h3 className={`${Style.ModalTitle} ${Style[`ModalTitle${variant}`]}`}>
          {title}
        </h3>

        {/* Mensagem */}
        <p className={Style.ModalMessage}>{message}</p>

        {/* Caminho */}
        <span className={`${Style.ModalPath} ${Style[`ModalPath${variant}`]}`}>
          {settingsHint}
        </span>

        {/* Ações */}
        <div className={Style.ModalActions}>
          <button
            className={Style.BtnSettings}
            style={{ background: bgColor, color: titleColor }}
            onClick={handleOpenSettings}
            disabled={opening}
          >
            {opening ? 'Abrindo…' : 'Abrir configurações'}
          </button>

          <button className={Style.BtnDismiss} onClick={fechar}>
            Ignorar
          </button>
        </div>
      </div>
    </div>
  );
}